import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type SalaryGradeFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues = {
  id: -1,
  name: '',
  status: defaultStatus,
} as SalaryGradeFormSchema;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/salary-grades', name: 'Salary Grades' },
];
